import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import "./scss/index.scss";
import * as React from "react";
import Media from "react-media";
import { smallScreen } from "../../globalStyles/scss/variables.scss";
import ProductRow from "./ProductRow";

var Table = function Table(_ref) {
  var lines = _ref.lines,
      rowProps = _objectWithoutProperties(_ref, ["lines"]);

  return React.createElement(Media, {
    query: {
      minWidth: smallScreen
    }
  }, function (mediumScreen) {
    return React.createElement("div", {
      className: "cart-table"
    }, React.createElement("div", null, lines.map(function (line) {
      return React.createElement(ProductRow, _extends({
        key: line.id,
        line: line,
        mediumScreen: mediumScreen
      }, rowProps));
    })));
  });
};

export default Table;